<div [formGroup]="taskForm" class="form flex flex-col gap-4">
  <nx-edit-text-input
    formControlName="title"
    [placeholder]="'Titel hinzufügen'"
    label="Titel">
  </nx-edit-text-input>
  <nx-textfield-input
    formControlName="description"
    [showLabel]="false"
    [placeholder]="'Beschreibung hinzufügen'"
    label="Beschreibung">
  </nx-textfield-input>
</div>
